videojs.addLanguage('nb', {
  "Audio Player": "Lydspiller",
  "Video Player": "Videospiller",
  "Play": "Spill",
  "Pause": "Pause",
  "Replay": "Spill om igjen",
  "Current Time": "Aktuell tid",
  "Duration": "Varighet",
  "Remaining Time": "Gjenstående tid",
  "Stream Type": "Type strøm",
  "LIVE": "DIREKTE",
  "Seek to live, currently behind live": "Hopp til live, spiller tidligere i sendingen nå",
  "Seek to live, currently playing live": "Hopp til live, spiller live nå",
  "Loaded": "Lastet inn",
  "Progress": "Framdrift",
  "Progress Bar": "Framdriftsviser",
  "progress bar timing: currentTime={1} duration={2}": "{1} av {2}",
  "Fullscreen": "Fullskjerm",
  "Non-Fullscreen": "Lukk fullskjerm",
  "Mute": "Lyd av",
  "Unmute": "Lyd på",
  "Playback Rate": "Avspillingshastighet",
  "Subtitles": "Teksting på",
  "subtitles off": "Teksting av",
  "Captions": "Teksting for hørselshemmede på",
  "captions off": "Teksting for hørselshemmede av",
  "Chapters": "Kapitler",
  "Descriptions": "Beskrivelser",
  "descriptions off": "beskrivelser av",
  "Audio Track": "Lydspor",
  "Volume Level": "Volumnivå",
  "You aborted the media playback": "Du avbrøt avspillingen.",
  "A network error caused the media download to fail part-way.": "En nettverksfeil avbrøt nedlasting av videoen.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Videoen kunne ikke lastes ned, på grunn av nettverksfeil eller serverfeil, eller fordi formatet ikke er støttet.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Videoavspillingen ble avbrudt på grunn av ødelagte data eller fordi videoen ville gjøre noe som nettleseren din ikke har støtte for.",
  "No compatible source was found for this media.": "Fant ikke en kompatibel kilde for dette mediainnholdet.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Mediefilen er kryptert og vi mangler nøkler for å dekryptere den.",
  "Play Video": "Spill av video",
  "Close": "Lukk",
  "Close Modal Dialog": "Lukk dialogvinduet",
  "Modal Window": "Dialogvindu",
  "This is a modal window": "Dette er et dialogvindu",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Vinduet kan lukkes ved å trykke på Escape-tasten eller lukkeknappen.",
  ", opens captions settings dialog": ", åpner innstillinger for teksting for hørselshemmede",
  ", opens subtitles settings dialog": ", åpner innstillinger for teksting",
  ", opens descriptions settings dialog": ", åpner innstillinger for beskrivelser",
  ", selected": ", valgt",
  "captions settings": "innstillinger for teksting",
  "subtitles settings": "innstillinger for teksting",
  "descriptions settings": "innstillinger for beskrivelser",
  "Text": "Tekst",
  "White": "Hvit",
  "Black": "Svart",
  "Red": "Rød",
  "Green": "Grønn",
  "Blue": "Blå",
  "Yellow": "Gul",
  "Magenta": "Magenta",
  "Cyan": "Turkis",
  "Background": "Bakgrunn",
  "Window": "Vindu",
  "Transparent": "Gjennomsiktig",
  "Semi-Transparent": "Delvis gjennomsiktig",
  "Opaque": "Ugjennomsiktig",
  "Font Size": "Tekststørrelse",
  "Text Edge Style": "Tekstkant",
  "None": "Ingen",
  "Raised": "Uthevet",
  "Depressed": "Nedtrykt",
  "Uniform": "Enkel",
  "Dropshadow": "Skygge",
  "Font Family": "Skrifttype",
  "Proportional Sans-Serif": "Proporsjonal skrift uten seriffer",
  "Monospace Sans-Serif": "Fastbreddeskrift uten seriffer",
  "Proportional Serif": "Proporsjonal skrift med seriffer",
  "Monospace Serif": "Fastbreddeskrift med seriffer",
  "Casual": "Uformell",
  "Script": "Skråskrift",
  "Small Caps": "Kapitéler",
  "Reset": "Tilbakestill",
  "restore all settings to the default values": "tilbakestill alle innstillinger til standardverdiene",
  "Done": "Ferdig",
  "Caption Settings Dialog": "Innstillingsvindu for teksting for hørselshemmede",
  "Beginning of dialog window. Escape will cancel and close the window.": "Begynnelse på dialogvindu. Trykk Escape for å avbryte og lukke vinduet.",
  "End of dialog window.": "Avslutning på dialogvindu.",
  "{1} is loading.": "{1} laster."
});